<template>
  <div class="container">
    <div>
      <header></header>
    </div>
    <div class="top_usermsgs">
      <div class="top_usermsg" :style="is_vip==1 ? 'background: #7E6B5A':'background: #2A292E'">
        <p class="set_up" @click="set_up()">设置</p>
        <img class="set_tu" src="@/static/images/my_index/set_up.png" alt @click="set_up()">
        <div class="div_img_ava">
          <img
            v-show="is_vip ==1 "
            class="vip_icon"
            :src="is_vip==1
              ? require('@/static/images/my_index/mine_ic_crowon.png')
              :require('@/static/images/my_index/mine_ic_evip_crown.png')"
            alt
          >
          <div class="user_head" :style="is_vip==1 ? 'border: #ebc28b 2px solid':'border: #fcffff 2px solid'">
            <img class="user_head_img" :src="user_head" onerror="javascript:this.src='https://newoss.zhulong.com/tfs/noavatar_big.gif'" alt>
          </div>
        </div>

        <div class="top_center">
          <p class="username">{{ username }} &nbsp;&nbsp;</p>
          <div v-if="user_grade" class="username_span">{{ user_grade }}</div>
          <img
            v-show="is_vip == 1"
            class="vip_small_icon"
            :src="is_vip==1
              ? require('@/static/images/my_index/mine_ic_vip.png')
              :require('@/static/images/my_index/mine_ic_evip_sign.png')"
            alt
          >
          <p class="huise">
            荣誉分
            <span style="padding-right: 20px">{{ ryf?ryf:0 }}</span><span v-if="agency_id==2">筑龙币 {{ zlb?zlb:0 }}</span>
          </p>
          <p class="huise">
            周学习时长
            <!-- <span>{{ xxsc?xxsc:0 }}分钟</span> -->
            <span v-if="Math.floor(study_hour/60)">{{ Math.floor(study_hour/60) }}</span><span v-if="Math.floor(study_hour/60)">小时</span>
            <span v-if="study_hour%60">{{ study_hour%60 }}</span><span v-if="study_hour%60">分钟</span>
            <span v-if="study_hour===0">{{ study_hour }}</span><span v-if="study_hour===0">分钟</span>
          </p>
          <p class="huise">
            发帖数
            <span>{{ fts?fts:0 }}个</span>
          </p>
        </div>
        <div
          v-show="is_show_vip"
          class="vips"
          :style="is_vip==1 ? 'background: #C29F73':'background: #7E6B5A'"
          @click="go_vip()"
        >
          <img
            class="vip_img"
            :src="is_vip==1
              ? require('@/static/images/my_index/vip_icon.png')
              :require('@/static/images/my_index/vip_img.png')"
            alt
          >
          <span class="shengji" :style="is_vip==1 ? 'border: 1px solid #D3B48B':'background: border: 1px solid #A38F7B'">{{ is_vip==1 ? '点击续费':'点击升级' }}</span>
        </div>
      </div>
      <!-- <div class="arc"> -->

      <!-- </div> -->
    </div>
    <div class="item_box1">
      <div v-for="(item1, index1) in list_menus_top" :key="index1" class="one_item" @click="clickOneMenu(item1)">
        <img class="icon" :src="item1.thumb" alt="">
        <span class="txt">{{ item1.name|| index1 }}</span>
      </div>
    </div>
    <!-- 菜单 -->
    <div class="list_menus">
      <div v-for="(item ,index) in list_menus" :key="index" class="menu_box">
        <div class="top_txt">
          <span class="redLine"></span>
          <p>{{ item.name }}</p>
        </div>
        <div class="item_box">
          <div v-for="(item1, index1) in item.children" :key="index1" class="one_item" @click="clickOneMenu(item1)">
            <img class="icon" :src="item1.thumb" alt="">
            <span class="txt">{{ item1.name }}</span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="agency_id==2">
      <div class="my_curriculum">
        <p class="my_curriculum_border"></p>
        <h3 class="my_curriculum_text">
          <span style></span>礼品兑换
        </h3>
        <p class="taskCenter" @click="taskCenter">
          任务中心
        </p>
        <p class="moreLp" @click="goMore()">
          更多礼品
          <!-- <span class="rightARRow">></span> -->
        </p>
        <!-- <img class="LpImg" src="" alt=""> -->
      </div>
      <div class="curriculum_listDh">
        <div
          v-for="(item,index) in giftlist"
          :key="index"
          class="listDHimg"
          @click="go_detailDh(item.id,index)"
        >
          <img class="LpImg" :src="item.img" alt>
        </div>
      </div>
      <!-- 收藏的专题 -->
      <div v-if="topicList.length>0" class="my_curriculum">
        <p class="my_curriculum_border"></p>
        <h3 class="my_curriculum_text">
          <span style></span>收藏的专题
        </h3>
        <!-- <p class="taskCenter" @click="taskCenter">
          任务中心
        </p> -->
        <p class="allTopic" @click="goMoreTopic()">
          <span>全部专题＞</span>
        </p>
      </div>
      <div v-if="topicList.length>0" class="topic_box">
        <div class="main_box">
          <div v-for="(item,index ) in topicList" :key="index" class="topic_item">
            <a :href="item.url"><img class="thumb" :src="item.banner" alt=""></a>
            <div class="collect">
              {{ getNum(item.collect_num) }}
              <span class="text">收藏</span>
            </div>
          </div>
        </div>
      </div>
      <div class="foot">
        <p>欢迎垂询: 400-900-8066</p>
      </div>
    </div>
    <footerNav active="/mine"></footerNav>
  </div>
</template>

<script>
import { get_user_msg, get_gift, getVipCardCollection } from '@/api/my_user.js'
import { getMyCenterInfo, getMenuList, getRow } from '@/api/newmine.js'

import tools from '@/utils/tools'
// import common from '@/components/homeBottom.vue'
import { getAppCommonStatis } from '@/api/hometop.js'

import Cookies from 'js-cookie'

// import { Toast } from 'vant'
export default {
  components: {
    // common
  },
  data() {
    return {
      is_show_vip: false,
      is_vip: '',
      user_head: '', // 头像url
      zlb: '', // 筑龙币
      username: '', // 用户名
      user_grade: '', // 用户等级
      ryf: '', // 荣誉分
      // xxsc: '', // 学习时长
      study_hour: 0, // 学习时长
      fts: '', // 发帖数
      list_menus_top: [],
      list_menus: [],
      lists: [],
      uid: '',
      pay_vip: '',
      pay_bbs: '',
      giftlist: [],
      // 收藏专题
      topicList: [],
      agency_id: Cookies.get('agency_id'),
    }
  },
  mounted() {
    this.getCenterMenus()
    // console.log(111)
    this.getGift()
    this.get_msg()
    this.getAppCommonStatis()
    this.getVipCardCollectionFun()
    // this.islogin()
  },
  methods: {
    // 点击菜单
    clickOneMenu(val) {
      console.log(val.url)
      this.$router.push({ path: val.url })
    },
    getCenterMenus() {
      getMenuList({ position: 5, type:2 }).then(res => {
        console.log(res)
        const errNo = res.errNo
        if (errNo === 0) {
          const result = res.result || []
          this.list_menus_top = result
        }
      })
      getRow().then(res => {
        console.log(res)
        const errNo = res.errNo
        if (errNo === 0) {
          this.sconename = res.result.name
        }
      })
      getMenuList({ position: 3, type:2  }).then(res => {
        console.log(res)
        const errNo = res.errNo
        if (errNo === 0) {
          const result = res.result || []
          // 没办法，所有机构不一样，但是接口统一了，并且还是ucenter的路径，疑似跳到筑龙去了
          // 暂时 机构id不为2的不显示那么多吧，接口不处理，暂时这样吧
          if (this.agency_id == 2) {
            this.list_menus = result
          } else {
            this.list_menus = result.filter(item => item.name === '我的课程')
          }
        }
      })
    },
    // 我收藏的专题
    getVipCardCollectionFun() {
      var info = {
        limit: 4
      }
      getVipCardCollection(info).then((res) => {
        if (res.errNo == 0) {
          this.topicList = res.result.list
        }
      })
    },
    // 更多收藏专题
    goMoreTopic() {
      this.$router.push({ path: '/collecttopic' })
    },
    // 任务中心
    taskCenter() {
      this.$router.push({ path: '/taskcenter' })
    },
    // 更多礼品
    goMore() {
      this.$router.push({
        path: '/gift'
      })
    },
    // 礼品兑换详情
    go_detailDh(id, index) {
      console.log(id)
      this.$router.push({
        path: '/gift/giftexchange',
        query: {
          id: id
        }
      })
    },
    // 礼品兑换列表
    getGift() {
      var params = {
        page: 1,
        limit: 15
      }
      get_gift(params).then(res => {
        this.giftlist = (res.result.zlProduct.slice(0, 4))
      })
    },
    // 判断用户是否登录
    // islogin(){

    // },
    // 获取用户信息
    get_msg() {
      // console.log(111)
      get_user_msg().then(res => {
        console.log(res)
        // debugger
        if (res.errNo !== 0) {
          this.$router.push('/login')
        } else if (res.errNo === 0) {
          const user_msg = res.result.user
          this.user_grade = user_msg.honour_title
          this.username = user_msg.username
          this.uid = user_msg.uid
          this.ryf = user_msg.honour_score
          this.fts = res.result.thread
          this.zlb = user_msg.score
          this.study_hour = res.result.hours
          this.user_head = user_msg.avatar
          this.is_vip = user_msg.is_vip
          this.pay_vip = tools.vipLink()
          this.pay_bbs = tools.bbsLink()
          this.is_show_vip = true
        }
      })
    },
    // 点击VIP
    go_vip() {
      window.location.href = this.pay_vip
    },
    // 点击e会员
    go_bbs() {
      if (this.pay_bbs) {
        window.location.href = this.pay_bbs
      }
    },
    // 设置
    set_up() {
      console.log(1)
      this.$router.push({
        path: '/set_up'
      })
    },
    // 我的社区
    go_communitys(index) {
      if (index === 2) { // 关注小组
        this.$router.push({ path: '/mine/community_xiaozu' })
      } else if (index === 3) { // 关注龙友
        this.$router.push({ path: '/mine/community_longyou' })
      } else if (index === 4) {
        this.$router.push({ path: '/mine/browsing_history' })
      } else if (index === 1) {
        this.$router.push({ path: '/mine/my_reply' })
      } else if (index === 0) {
        this.$router.push({ path: '/mine/my_post' })
      }
    },
    // 我的课程
    go_purchased_ke(index) {
      // console.log(index)
      if (index === 0) {
        this.$router.push({ path: '/mine/my_curriculum' })
      } else if (index === 1) {
        this.$router.push({ path: '/mine/freelesson' })
      } else if (index === 2) {
        this.$router.push({ path: '/mine/to_be_paid' })
      } else if (index === 3) {
        this.$router.push({ path: '/mine/viewing_record' })
      } else if (index === 4) {
        this.$router.push({ path: '/mine/my_collection' })
      } else if (index == 5) {
        this.$router.push({ path: '/mine/satisfaction' })
      }
    },
    // 列表跳转
    go_detail(index) {
      if (index === 0) {
        // index1==评测
        this.$router.push({ path: '/mine/evaluating', query: { states: 1 }})
      } else if (index === 2) {
        this.$router.push({ path: '/mine/express', query: { states: 1 }})
      } else if (index === 1) {
        this.$router.push({ path: '/mine/coupon', query: { states: 1 }})
      } else if (index === 3) {
        this.$router.push({ path: '/mine/certificate_query', query: { states: 1 }})
      } else if (index === 4) {
        this.$router.push({ path: '/mine/ExchangeCode', query: { states: 1 }})
      }
    },
    // 我的资料
    go_ziliao(index) {
      if (index === 2) {
        this.$router.push({ path: '/mine/collect_data' })
      } else if (index === 0) {
        this.$router.push({ path: '/mine/my_updata' })
      } else if (index === 1) {
        this.$router.push({ path: '/mine/my_down' })
      } else if (index === 3) {
        this.go_bbs()
      }
    },
    // 三方统计
    getAppCommonStatis() {
      getAppCommonStatis().then(res => {
        console.log(res, 'res')
        this.statis = res.result
        // var bd_script = document.createElement('script')
        // bd_script.type = 'text/javascript'
        // bd_script.innerHTML = this.statis.baidu_h5
        // console.log(this.statis, 'this.statis')
        // document.head.appendChild(bd_script)
        var cc_script = document.createElement('script')
        cc_script.type = 'text/javascript'
        if (this.statis){
            cc_script.innerHTML = this.statis.circle
        }
        document.head.appendChild(cc_script)
        var cz_script = document.createElement('script')
        cz_script.type = 'text/javascript'
        cz_script.src = 'https://s4.cnzz.com/z_stat.php?id=5078536&web_id=5078536'
        // cz_script.innerHTML = this.statis.cnzz
        document.head.appendChild(cz_script)
      })
    },
    getNum(num) {
      if (num < 1000) {
        return num
      } else if (num >= 1000 && num < 10000) {
        return parseInt((num / 1000 * 10)) / 10 + 'k'
      } else if (num >= 10000) {
        return parseInt((num / 10000 * 10)) / 10 + 'w'
      }
    }
  }
}
</script>

<style lang="scss" scoped >
.container {
  background-color: #f4f4f4;
  padding-bottom: 100px;
  min-height: calc(100vh - 100px);
}
@keyframes aa {
  from {
    top: 300px;
  }
  to {
    top: 285px;
  }
}
.rightARRow {
  color: #999;
  position: relative;
  left: 10px;
  // top: 4px;
  top: 1px;
}
.LpImg {
  width: 144px;
  height: 144px;
  background: #98989a;
  margin-top: 15px;
}
.moreLp {
  font-family: PingFangSC-Regular;
  position: absolute;
  right: 20px;
  top: 24px;
  color: #ee2e2e;
  width: 120px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-radius: 20px;
  border: 1px solid #ee2e2e;
}
.taskCenter {
  position: absolute;
  right: 160px;
  font-family: PingFangSC-Regular;
  top: 24px;
  color: #ee2e2e;
  width: 120px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-radius: 20px;
  border: 1px solid #ee2e2e;
}
.curriculum_listDh {
  width: 100%;
  height: 180px;
  background: white;
  display: flex;
  justify-content: space-around;
  border-bottom: 20px solid #f5f5f5;
}
.vip_img {
  width: 141px;
  height: 38px;
  position: absolute;
  left: 50px;
  top: 13px;
}
#my_class:last-child {
  visibility: hidden;
}
.vips {
  width: 230px;
  height: 184px;
  position: absolute;
  bottom: -30px;
  right: -10px;
  border-radius: 20px;
  transform: rotate(-15deg);
  animation: aa 0.7s infinite;
  -webkit-animation: aa 0.7s infinite;
  animation-direction: alternate;
  -webkit-animation-direction: alternate;
  // z-index: 999;
}
.shengji {
  color: #f3e2ce;
  font-weight: 300;
  // text-align: center;
  display: inline-block;
  margin: 58px 0 0 55px;
  padding: 2px 20px 1px 20px;
  border-radius: 30px;
  transform: scale(0.8);
}
// .vips:after{
//   height: 80px;
//   width: 100%;
//     background: #7b6b5c;
//     border-radius:50%;
//   position: absolute;
//   content:'';
//     left: 0;
//     bottom: -10px;
//     z-index: -1;
// }
.top_usermsgs {
  height: 419px;
  width: 100%;
  position: relative;
  background-color: #fff;
  // z-index: -2;
}
// .top_usermsg:after{
//   height: 102px;
//   width: 100%;
//     background: #2a292e;
//     border-radius:50%;
//   position: absolute;
//   content:'';
//     left: 0;
//     bottom: -51px;
//     z-index: -1;

// }
.top_usermsg {
  width: 100%;
  height: 419px;
  // overflow: hidden;
  position: relative;
  border-radius: 0 0 50% 50% / 0 0 52px 52px;
  // transform: rotate(-20deg);
  // position: relative;
  // width: 250px;
  // height: 100px;
  // margin-left: 106px;
  overflow: hidden;
}
.arc {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -3px;
  z-index: -1;
  content: "";
  height: 102px;
  width: 100%;
  border-radius: 50%;
  // background-image: linear-gradient(to right, #f6aa52 0%, #e9594e 100%);
  background: #2a292e;
}
.div_img_ava{
   width: 155px;
   position: relative;
  .user_head {
    width: 155px;
    height: 155px;
    border-radius: 50%;
    margin: 136px 0 0 30px;
    float: left;
    overflow: hidden;
  }
  .vip_icon {
    position: absolute;
    margin: 120px 0 0 30px;
    width: 42px;
    height: 42px;
  }
  .user_head_img {
    width: 155px;
    height: 155px;
  }
}
.vip_small_icon {
  position: absolute;
  width: 34px;
  height: 34px;
  margin-left: 20px;
  margin-top: 8px;
}
.username {
  color: #fff;
  font-weight: 600;
  font-size: 30px;
  margin-right: 20px;
  display: inline-block;
}
.top_center {
  margin: 140px 0 0 40px;
  float: left;
  line-height: 50px;
}
.username_span {
  display: inline-block;
  background: #caaa7b;
  color: #312d12;
  height: 40px;
  border-radius: 30px;
  padding: 0 15px 5px 15px;
  // display: inline-block;
  // margin-left: 15px;
}
.huise {
  color: #98989a;
}
.huise span {
  color: #ac9b7d;
  padding-left: 10px;
}
.set_up {
  color: #fefdff;
  font-size: 34px;
  position: absolute;
  right: 77px;
  top: 68px;
}
.set_tu {
  width: 45px;
  height: 45px;
  position: absolute;
  right: 17px;
  top: 70px;
}
.lists {
  margin: 57px 0 50px 0;
  display: flex;
  justify-content: space-around;
}
.lists_dl {
  width: 100px;
  float: left;
}
.lists_dl dt img {
  width: 76px;
  height: 76px;
  margin-left: 12px;
}
.lists_dl dd {
  text-align: center;
  color: #3c3c3c;
}
.geduan {
  width: 100%;
  height: 20px;
  background: #f5f5f5;
}
#my_curriculum {
  position: relative;
  background: white;
}
.my_curriculum {
  position: relative;
  height: 88px;
  width: 100%;
  border-bottom: 2px solid #f5f5f5;
  background: white;
}
.my_curriculum_text {
  line-height: 88px;
  color: #303030;
  padding: 2px 0 0 20px;
  margin-left: 30px;
  font-size: 30px;
  font-weight: 800;
  // float: left;
}
.my_curriculum_border {
  float: left;
  display: inline-block;
  width: 5px;
  height: 34px;
  background: #db403b;
  margin: 28px 0 0 30px;
}
.curriculum_list {
  width: 100%;
  // height: 160px;
  display: flex;
  // justify-content: space-around;
  flex-wrap: wrap;
  border-bottom: 20px solid #f5f5f5;
}
.curriculum_lists_dl {
  float: left;
  width: 104px;
  margin: 35px 10px 30px;
}
.curriculum_lists_dl dt img {
  width: 55px;
  height: 55px;
  // margin: 0 auto;
  margin-left: 25px;
}
.curriculum_lists_dl dd {
  text-align: center;
  color: #3c3c3c;
}
#my_ziliao:last-child {
  visibility: hidden;
}
// #my_ziliao:nth-child(4) {
//   visibility: hidden;
// }
.more {
  position: absolute;
  right: 75px;
  top: 30px;
  font-weight: 300;
  color: #aaa9a9;
}
.foot {
  text-align: center;
  line-height: 50px;
  padding-top: 20px;
  padding-bottom: 120px;
  color: #999;
}
.allTopic {
  position: absolute;
  right: 50px;
  font-family: PingFangSC-Regular;
  top: 24px;
  // color: #ee2e2e;
  width: 120px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  // border-radius: 20px;
  // border: 1px solid #ee2e2e;
  i{
    font-size:24px;
  }
}
.topic_box{
  width: 100%;
  display: flex;
  overflow-x: scroll;
}
.main_box{
  padding: 28px;
  // display: flex;
  // flex-wrap: wrap;
  // width: 1842px;
  flex-shrink:0;
  height: 189px;
  .topic_item{
    width: 443px;
    height: 189px;
    margin-right: 23px;
    // margin-bottom: 30px;
    position:relative;
    float: left;
    .thumb{
      width: 100%;
      height: 100%;
    }
    .collect{
      position:absolute;
      bottom:0;
      right: 0;
      background: rgba(51,51,51,0.90);
      border-radius: 12px 0px 0px 0px;
      color:#fff;
      padding: 4px 20px;
      font-size: 24px;
      .text{
        margin-left: 4px;
      }
    }
    &:nth-last-child(1){
      margin-right: 0;
    }
  }
}
.list_menus {
  margin: 18px 0;
  background-color: #f4f4f4;
  .menu_box {
    font-family: PingFangSC-Regular;
    font-size: 32px;
    color: #333333;
    letter-spacing: 0;
    background-color: white;
    .top_txt {
      background: white;
      margin-top: 18px;
      padding: 20px 30px;
      font-weight: 600;
      border-bottom: 4px solid rgba(244,245,244,1);;
      display: flex;
      flex-direction: row;
      align-items: center;
      .redLine {
        margin-right: 20px;
        display: block;
        width: 5px;
        height: 30px;
        margin-top: 7px;
        background-color: #ee2e2e;
      }
    }
    .item_box {
      background: white;
      display: flex;
      flex-direction: row;
      justify-content: start;
      flex-wrap: wrap;
      .one_item {
        padding: 40px 0 22px;
        width: 20%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .icon {
          width: 46.2px;
          height: 46.2px;
          display: block;
        }
        .txt {
          margin-top: 10px;
          font-size: 24px;
        }
      }
    }
  }
}
.item_box1 {
  padding: 0 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  background: white;
  .one_item {
    padding: 48px 0 24px;
    flex:1;
    display: flex;
    flex-direction: column;
    align-items: center;
    .icon {
      width: 74px;
      height: 74px;
      display: block;
    }
    .txt {
      margin-top: 14px;
      font-size: 26px;
    }
  }
}
</style>
